module.exports = __webpack_public_path__ + "img/whatsapp.da7c7186.png";